import axios from 'axios'
import store from '@/store/'

axios.defaults.baseURL = process.env.VUE_APP_API

// Request interceptor
axios.interceptors.request.use(request => {
	const token = store.getters.getToken

	if (token) {
		request.headers.common['Authorization'] = `Bearer ${token}`
	}

	return request
})

axios.interceptors.response.use(response => response, error => {
	const { status } = error.response

	if (status >= 500) {

	}

	if (status === 401 && store.getters.getLoggedInState) {

	}

	return Promise.reject(error)
})
